export interface ArticleContent {
  id: number;
  comicId: number;
  title: string;
  content: string;
}

export const articleContents: ArticleContent[] = [
  {
    id: 1,
    comicId: 1,
    title: "斗破苍穹",
    content: `《斗破苍穹》是由著名网络作家天蚕土豆创作的玄幻小说改编漫画，故事发生在一个充满斗气的世界。

## 故事背景

在这个世界中，没有花哨的魔法，有的仅仅是繁衍到巅峰的斗气。斗者、斗师、大斗师、斗灵、斗王、斗皇、斗宗、斗尊、斗圣、斗帝，每一个等级都代表着实力的巨大差距。

## 主角介绍

萧炎，曾经是萧家空前绝后的天才，四岁练气、十岁拥有九段斗之气、十一岁突破十段斗之气成为斗者。然而在他十一岁那年，一身修为却在一夜之间化为乌有，从此跌落神坛，成为人人嘲笑的对象。

## 精彩看点

- 戒指中的神秘老者药老，将带领萧炎走上一条全新的修炼之路
- 炼丹术的神奇世界，异火榜上的神秘火焰
- 辽阔的斗气大陆，中州的繁华与危险
- 远古八大家族的恩怨纠葛
- 魂殿的阴谋与整个大陆的命运

## 作品评价

《斗破苍穹》作为中国网络文学的代表作品之一，以其宏大的世界观、跌宕起伏的剧情和鲜明的人物塑造，赢得了数亿读者的喜爱。漫画改编版完美还原了原著的精髓，画风精美细腻，是漫画爱好者不容错过的经典之作。`,
  },
  {
    id: 2,
    comicId: 2,
    title: "一人之下",
    content: `《一人之下》是米二创作的中国漫画作品，以其独特的世界观和深厚的中式文化底蕴，成为了近年来最受欢迎的中国漫画之一。

## 故事简介

主角张楚岚原本只是一个普通的大学生，因为爷爷尸体的神秘失踪而卷入异人世界。在追寻真相的过程中，他认识了神秘少女冯宝宝，并逐渐揭开了自己身世的秘密。

## 世界观

异人，是指拥有特殊能力的人类。在这个世界里，异人以各种门派、家族的形式存在着，他们拥有常人无法想象的超能力。天师府、全性、天下会、唐门……各大势力明争暗斗，演绎着现代版的江湖传奇。

## 独特之处

- 融入了大量中国传统道家和民间文化元素
- 奇门遁甲、炁体源流等概念的现代化演绎
- 方言对白的巧妙运用，增添了浓郁的地域特色
- 幽默与严肃情节的完美结合
- 精彩的打斗场面和智斗桥段

## 读者评价

"这是我读过最具中国特色的漫画，没有之一。它不模仿日本漫画的模式，而是走出了属于自己的风格。"——来自一位资深漫画读者的评价。

《一人之下》不仅在国内取得了巨大成功，在海外也拥有大量粉丝，是中国漫画走向世界的代表作品。`,
  },
  {
    id: 3,
    comicId: 3,
    title: "星辰变",
    content: `《星辰变》改编自我吃西红柿的同名小说，是一部将修仙与宇宙星辰融合在一起的奇幻作品。

## 内容概述

主角秦羽天生无法修炼内功，但他没有向命运低头。在得到流星泪这一神秘宝物后，他开创了属于自己的修炼之路——星辰变功法，以宇宙星辰之力淬炼自身，最终成为了掌控星辰的绝世强者。

## 修炼体系

星辰变功法的修炼分为多个阶段：星云期、流星期、星核期、行星期、渡劫期、恒星期、暗星期、黑洞期、原点期、乾坤期、宇宙之主。每一阶段的突破都伴随着翻天覆地的变化。

## 世界格局

从潜龙大陆到无边海域，从仙魔妖界到神界，主角的脚步跨越了一个又一个世界。每一个世界都有其独特的文明与修炼体系。

## 漫画特色

- 漫画对星空和宇宙场景的描绘极为精美
- 主角成长曲线清晰，每一阶段都有明确的目标
- 战斗场面的想象力丰富，视觉冲击力强
- 情感线的处理细腻动人`,
  },
  {
    id: 4,
    comicId: 4,
    title: "怦然心动",
    content: `《怦然心动》是kid岁创作的青春校园恋爱漫画，以其清新自然的画风和真实细腻的情感描写，成为了恋爱类漫画中的经典之作。

## 故事大纲

高中生狄淇儿因为家庭原因转学到了新的学校，在这里她遇到了性格冷傲的江应怜。两人从陌生到相识，从误会到理解，一段纯真美好的校园恋情悄然展开。

## 人物特色

- 狄淇儿：活泼开朗，善良纯真，像一缕阳光照进江应怜的世界
- 江应怜：外表冷酷内心温柔，成绩优异，有着不为人知的家庭故事
- 配角阵容丰富，每个角色都有完整的故事线

## 作品亮点

漫画的画风清新唯美，对人物表情和肢体语言的刻画极为细腻。作者擅长通过日常的小细节展现角色之间的情感变化，让读者能够真切地感受到青春期那份懵懂而美好的心动。

## 读者反馈

"看着狄淇儿和江应怜的故事，仿佛回到了自己的高中时代。那些青涩的心动、那些默默的关注，都是青春最美好的回忆。"`,
  },
  {
    id: 5,
    comicId: 5,
    title: "十万个冷笑话",
    content: `《十万个冷笑话》是寒舞创作的搞笑吐槽类漫画，以独特的幽默风格和天马行空的想象力，给读者带来无限的欢乐。

## 作品风格

漫画以短篇故事为主，每一话都会对某个经典故事、神话传说或流行文化进行脑洞大开的改编和恶搞。从哪吒到葫芦娃，从西游记到三国演义，没有什么是不可以被"冷"一下的。

## 经典角色

- 李靖：一个被儿子哪吒各种坑的悲催老爹
- 哪吒：一出生就自带吐槽属性的问题儿童
- 葫芦娃：七个性格迥异的兄弟，各有各的奇葩之处
- 匹诺曹：一个不能说谎但总是被各种套路的小木偶

## 作品影响

《十万个冷笑话》开创了中国网络漫画的吐槽流风格，其动画改编版也在各大视频平台取得了极高的播放量。"百分百被空手接白刃"等梗更是成为了网络流行语。

## 适合人群

如果你喜欢轻松搞笑的内容，如果你想在工作学习之余放松心情，那么《十万个冷笑话》绝对是你的不二之选！`,
  },
];

export const getArticleByComicId = (comicId: number): ArticleContent | undefined => {
  return articleContents.find((a) => a.comicId === comicId);
};